"use strict";

import { CDN } from '@autoguru/global-configs';
import { HeaderLayout } from '@autoguru/header-layout';
import { Column, Columns } from '@autoguru/overdrive';
import { Picture } from '@autoguru/picture';
import { jsx as _jsx } from "react/jsx-runtime";
export const AppHeader = () => /*#__PURE__*/_jsx(HeaderLayout, {
  safePaddings: true,
  children: /*#__PURE__*/_jsx(Columns, {
    noWrap: true,
    space: "5",
    children: /*#__PURE__*/_jsx(Column, {
      noShrink: true,
      alignSelf: "centre",
      display: "flex",
      flexDirection: "row",
      children: /*#__PURE__*/_jsx(Picture, {
        aspectRatio: 5.1,
        height: 24,
        backgroundColor: "transparent",
        src: `${CDN}/images/logos/autoguru.svg`,
        altText: "AutoGuru logo"
      })
    })
  })
});